@if (totalCount() == 0) {
  <div id="attachments-empty-state" role="status" class="w-full flex items-center justify-center p-4">
    No Attachments found
  </div>
} @else {
  <div id="attachments-container" class="flex flex-col">
    <div id="attachments-grid"
         class="px-8 py-4 bg-white rounded-lg shadow flex justify-center items-start gap-4 flex-wrap">
      @for (item of attachments(); track $index) {
        <attachment-card [attachment]="item" [idPostfix]="String($index)"/>
      }
      @if (totalCount() > 5) {
        <div id="attachments-show-more" class="w-full mt-4 flex justify-end">
          <a id="attachments-show-more-link" (click)="handleShowMore()"
             class="text-blue-500 hover:underline cursor-pointer">Show More</a>
        </div>
      }
    </div>
  </div>
}
